import React, {useEffect, useState} from "react";
import "./Sidebar.css";
import burgerMenu from "./burgermenu.svg";
import {NavLink, useLocation} from "react-router-dom";
import {AiFillCalendar, AiFillHome, AiOutlineDatabase} from "react-icons/ai";
import {MdContactPage, MdHomeRepairService, MdOutlineAddHome, MdOutlineAppRegistration} from "react-icons/md";
import {ImMap} from "react-icons/im";
import {
    FaExchangeAlt,
    FaFileArchive,
    FaFilePdf,
    FaNewspaper,
    FaPen,
    FaPlus,
    FaRegAddressBook,
    FaUserEdit
} from "react-icons/fa";
import {IoMdSettings} from "react-icons/io";
import {jwtDecode} from "jwt-decode";
import {FaCircleInfo, FaQ, FaRegHardDrive} from "react-icons/fa6";
import {GoProjectTemplate} from "react-icons/go";
import {TfiWrite} from "react-icons/tfi";
import {PiTreeStructureBold} from "react-icons/pi";
import {VscGistSecret} from "react-icons/vsc";
import {Tooltip} from "@mui/material";
import departmentEnums from "../../../enums/departmentEnums";
import {IoBuildOutline, IoDocumentsOutline} from "react-icons/io5";
import axios from "axios";


const getUserRole = () => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.role || null;
        } catch (error) {
            return null;
        }
    }
    return null;
};

const getUserDepartmentRole = () => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.DepartmentId || null;
        } catch (error) {
            return null;
        }
    }
    return null;
};

const getUserPermissions = () => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.CanEditObjectRegister === "True" ? "canEdit" : "cannotEdit";
        } catch (error) {
            return "error"; // It's better to handle the error scenario explicitly.
        }
    }
    return "noToken"; // Indicate that no token was found.
};


const Sidebar = ({hasClicked = 0}) => {
    const token = localStorage.getItem('jwtToken');
    const userRole = getUserRole();
    const userPermistion = getUserPermissions();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const userDepartment = getUserDepartmentRole();
    const location = useLocation();
    const [count, setCount] = useState(0);
    const [adminCount, setAdminCount] = useState(0);
    const isMobile = window.innerWidth < 768;
    const [isBuildingDepartment, setIsBuildingDepartment] = useState(false);
    const [isOpen, setIsOpen] = useState(() => {
        const storedIsOpen = localStorage.getItem("isOpen");
        return storedIsOpen ? JSON.parse(storedIsOpen) : true;
    });


    const seenByHeadOfAgency = async () => {

        if (userRole === "")
            return
        if (userRole !== "HEADOFAGENCY")
            return
        if (location.pathname !== "/dashboard/rewrite") {
            return
        }

        try {
            await axios.put(`${baseURL}/UpdateCaseRewriteRequesLoggerViewedByHeadOfAgencyTrue`, {});
        } catch {
        }
    };

    const getCaseCount = async () => {
        if (userRole === "")
            return
        if (userRole !== "HEADOFAGENCY" && userRole !== "ROOTADMIN")
            return
        if (location.pathname === "/dashboard/rewrite" && userRole === "HEADOFAGENCY") {
            setCount(0);
            return
        }

        try {
            const response = await axios.get(`${baseURL}/GetAllCaseRewriteRequestAndLog?GetViewedByHeadOfAgencycount=true`, {});
            if (userRole === "HEADOFAGENCY") {
                setCount(response.data.data.viewedByHeadOfAgencycount)
            }
            if (userRole === "ROOTADMIN") {
                setAdminCount(response.data.data.reesolvedByAdmincount)
            }
        } catch {
        }
    };


    useEffect(() => {
        void getCaseCount()
        void seenByHeadOfAgency();

    }, [userRole, location, hasClicked]);

    useEffect(() => {
        localStorage.setItem("isOpen", JSON.stringify(isOpen));
    }, [isOpen]);


    useEffect(() => {
        if (userDepartment && parseInt(userDepartment) === departmentEnums.building.id) {
            setIsBuildingDepartment(true)
        }
    }, [userDepartment, token]);
    return (
        <div>
            {!isMobile && (
                <>
                    <div className={`sidebar-dashboard ${isOpen ? "open" : "closed"}`}>
                        <button className={`burger-menu ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                            <img src={burgerMenu} alt="sidebar-icon"/>
                        </button>

                        <ul className={"sidebar-dashboard-ul"}>
                            {userRole !== 'ROOTADMIN' && (
                                <>
                                    <NavLink
                                        className="sidebar-link"
                                        activeclassname="active"

                                        to={"/dashboard/home"}
                                    >
                                        <li className={"sidebar-dashboard-li"}>
                                            <Tooltip title={!isOpen ? "შეტყობინებები" : ""}>
                                                <div>
                                                    <AiFillHome className="sidebar-dashboard-icon"/>
                                                </div>
                                            </Tooltip>
                                            {isOpen && <span className="sidebar-dashboard-text">შეტყობინებები</span>}
                                        </li>
                                    </NavLink>
                                    <>
                                        {userRole === "USER" && (
                                            <NavLink
                                                className="sidebar-link"
                                                activeclassname="active"
                                                to={"/dashboard/services"}
                                            >
                                                <li className={"sidebar-dashboard-li"}>
                                                    <Tooltip title={!isOpen ? "სერვისები" : ""}>
                                                        <div>
                                                            <MdHomeRepairService className="sidebar-dashboard-icon"/>
                                                        </div>
                                                    </Tooltip>
                                                    {isOpen &&
                                                        <span className="sidebar-dashboard-text">სერვისები</span>}
                                                </li>
                                            </NavLink>
                                        )}

                                    </>
                                    {!isBuildingDepartment && (
                                        <NavLink
                                            className="sidebar-link"
                                            activeclassname="active"
                                            to={"/dashboard/registery"}
                                        >
                                            <li className={"sidebar-dashboard-li"}>
                                                <Tooltip title={!isOpen ? "უწყებრივი რეესტრი" : ""}>
                                                    <div>
                                                        <AiOutlineDatabase className="sidebar-dashboard-icon"/>
                                                    </div>
                                                </Tooltip>
                                                {isOpen && (
                                                    <span className="sidebar-dashboard-text">უწყებრივი რეესტრი</span>
                                                )}
                                            </li>
                                        </NavLink>
                                    )}
                                    {!isBuildingDepartment && userRole !== "USER" && (
                                        <NavLink
                                            className="sidebar-link"
                                            activeclassname="active"
                                            to={"/dashboard/registerydocs"}
                                        >
                                            <li className={"sidebar-dashboard-li"}>
                                                <Tooltip title={!isOpen ? "უწყებრივი რეესტრის დოკუმენტები" : ""}>
                                                    <div>
                                                        <IoDocumentsOutline className="sidebar-dashboard-icon"/>
                                                    </div>
                                                </Tooltip>
                                                {isOpen && (
                                                    <span className="sidebar-dashboard-text">უწყებრივი რეესტრის
                                                        დოკუმენტები</span>
                                                )}
                                            </li>
                                        </NavLink>
                                    )}
                                    {!isBuildingDepartment && userRole !== "USER" && (
                                        <NavLink
                                            className="sidebar-link"
                                            activeclassname="active"
                                            to={"/dashboard/oldobjects"}
                                        >
                                            <li className={"sidebar-dashboard-li"}>
                                                <Tooltip title={!isOpen ? "ძველი უწყებრივი რეესტრის ობიექტები" : ""}>
                                                    <div>
                                                        <IoBuildOutline className="sidebar-dashboard-icon"/>
                                                    </div>
                                                </Tooltip>
                                                {isOpen && (
                                                    <span className="sidebar-dashboard-text">
                                                        ძველი უწყებრივი რეესტრის ობიექტები
                                                    </span>
                                                )}
                                            </li>
                                        </NavLink>
                                    )}


                                    <NavLink
                                        className="sidebar-link"
                                        activeclassname="active"
                                        to={"/dashboard/map"}
                                    >
                                        <li className={"sidebar-dashboard-li"}>
                                            <Tooltip title={!isOpen ? "ინტერაქტიული რუკა" : ""}>
                                                <div>
                                                    <ImMap className="sidebar-dashboard-icon"/>
                                                </div>
                                            </Tooltip>
                                            {isOpen && (
                                                <span className="sidebar-dashboard-text">ინტერაქტიული რუკა</span>
                                            )}
                                        </li>
                                    </NavLink>


                                    {userPermistion && userRole && userRole !== "USER" && userRole !== "ROOTADMIN" && ((userRole === "EXPERT" && userPermistion === "canEdit") || userRole === "HEADOFAGENCY") && (
                                        <NavLink
                                            className="sidebar-link"
                                            activeclassname="active"
                                            to={"/dashboard/objectregistration"}
                                        >
                                            <li className={"sidebar-dashboard-li"}>
                                                <Tooltip
                                                    title={!isOpen ? "უწყებრივ რეესტრში ობიექტის რეგისტრაცია" : ""}>
                                                    <div>
                                                        <FaPlus className="sidebar-dashboard-icon"/>
                                                    </div>
                                                </Tooltip>
                                                {isOpen &&
                                                    <span className="sidebar-dashboard-text">უწყებრივ რეესტრში ობიექტის
                                                        რეგისტრაცია</span>}
                                            </li>
                                        </NavLink>
                                    )}

                                    <>
                                        {userRole !== "USER" && (
                                            <NavLink
                                                className="sidebar-link"
                                                activeclassname="active"
                                                to={"/dashboard/documents"}
                                            >
                                                <li className={"sidebar-dashboard-li"}>
                                                    <Tooltip title={!isOpen ? "დოკუმენტები" : ""}>
                                                        <div>
                                                            <FaFileArchive className="sidebar-dashboard-icon"/>
                                                        </div>
                                                    </Tooltip>
                                                    {isOpen &&
                                                        <span className="sidebar-dashboard-text">დოკუმენტები</span>}
                                                </li>
                                            </NavLink>
                                        )}

                                    </>

                                </>

                            )
                            }
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/pagemanager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "გვერდების მენეჯერი" : ""}>
                                            <div>

                                                <MdContactPage className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">გვერდების მენეჯერი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (

                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/newsmanager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "სიახლეები" : ""}>
                                            <div>
                                                <FaNewspaper className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">სიახლეები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}

                            {userRole === 'ROOTADMIN' && (

                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/mainpagemanager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "მთავარი გვერდი" : ""}>
                                            <div>
                                                <MdOutlineAddHome className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">მთავარი გვერდი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (

                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/StructurePageManager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "სტრუქტურა" : ""}>
                                            <div>
                                                <PiTreeStructureBold className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">სტრუქტურა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/partnermanager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "პარტნიოერები" : ""}>
                                            <div>
                                                <FaRegAddressBook className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">პარტნიოერები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/holiday"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "დასვენების დღეები" : ""}>
                                            <div>
                                                <AiFillCalendar className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">დასვენების დღეები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/faqmanager"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "FAQ" : ""}>
                                            <div>
                                                <FaQ className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">FAQ</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/hidecases"}
                                >

                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "განაცხადების დამალვა" : ""}>
                                            <div>
                                                <VscGistSecret className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">განაცხადების დამალვა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {/*{userRole === 'ROOTADMIN' && (*/}
                            {/*    <NavLink*/}
                            {/*        className="sidebar-link"*/}
                            {/*        activeclassname="active"*/}
                            {/*        to={"/dashboard/eurointegrationmanager"}*/}
                            {/*    >*/}
                            {/*        <li className={"sidebar-dashboard-li"}>*/}
                            {/*            <Tooltip title={!isOpen ? "ევროინტეგრაცია" : ""}>*/}
                            {/*                <div>*/}
                            {/*                    <GiEuropeanFlag className="sidebar-dashboard-icon"/>*/}
                            {/*                </div>*/}
                            {/*            </Tooltip>*/}
                            {/*            {isOpen && (*/}
                            {/*                <span className="sidebar-dashboard-text">ევროინტეგრაცია</span>*/}
                            {/*            )}*/}
                            {/*        </li>*/}
                            {/*    </NavLink>*/}
                            {/*)}*/}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/addnewpermitfile"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "სანებართვო დოკუმენტები" : ""}>
                                            <div>
                                                <MdHomeRepairService className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">სანებართვო დოკუმენტები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/dictionary"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "ცნობარი" : ""}>
                                            <div>
                                                <FaCircleInfo className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">ცნობარი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/adminregistration"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "მომხმარებლების კონტროლი" : ""}>
                                            <div>
                                                <MdOutlineAppRegistration className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">მომხმარებლების კონტროლი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}

                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/inputfieldsglobal"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "შესაყვანი ველები" : ""}>
                                            <div>
                                                <FaPen className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">შესაყვანი ველები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/newdoctypes"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "შაბლონის შექმნა" : ""}>
                                            <div>
                                                <GoProjectTemplate className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">შაბლონის შექმნა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}

                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/settings"}
                                >

                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "პარამეტრები" : ""}>
                                            <div>
                                                <IoMdSettings className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">პარამეტრები</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {(userRole === 'ROOTADMIN' || userRole === 'HEADOFAGENCY') && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/rewrite"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "განაცხადის გადაწერა" : ""}>
                                            <div style={{position: "relative"}}>
                                                <TfiWrite className="sidebar-dashboard-icon"/>
                                                {count > 0 && userRole === "HEADOFAGENCY" && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            right: 0,
                                                            transform: "translate(50%, -50%)",
                                                            backgroundColor: "#e53935",
                                                            color: "#fff",
                                                            borderRadius: "999px",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            padding: "2px 6px",
                                                            minWidth: "18px",
                                                            height: "18px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            lineHeight: 1,
                                                            boxShadow: "0 0 0 2px white",
                                                            zIndex: 1,
                                                        }}

                                                    >
                                                        {count}
                                                    </span>
                                                )}
                                                {adminCount > 0 && userRole === "ROOTADMIN" && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            right: 0,
                                                            transform: "translate(50%, -50%)",
                                                            backgroundColor: "#e53935",
                                                            color: "#fff",
                                                            borderRadius: "999px",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            padding: "2px 6px",
                                                            minWidth: "18px",
                                                            height: "18px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            lineHeight: 1,
                                                            boxShadow: "0 0 0 2px white",
                                                            zIndex: 1,
                                                        }}

                                                    >
                                                        {adminCount}
                                                    </span>
                                                )}
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">განაცხადის გადაწერა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}

                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/filedrive"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "საჯარო დოკუმენტების საცავი" : ""}>
                                            <div>
                                                <FaRegHardDrive className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">საჯარო დოკუმენტების საცავი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/admincases"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "შემსრულებლის შეცვლა" : ""}>
                                            <div>
                                                <FaUserEdit className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">შემსრულებლის შეცვლა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/pdf"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "pdf-ის გენერატორი" : ""}>
                                            <div>
                                                <FaFilePdf className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">pdf-ის გენერატორი</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === 'ROOTADMIN' && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/changenomenclature"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip title={!isOpen ? "ნომენკლატურის შეცვლა" : ""}>
                                            <div>
                                                <FaExchangeAlt className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen && (
                                            <span className="sidebar-dashboard-text">ნომენკლატურის შეცვლა</span>
                                        )}
                                    </li>
                                </NavLink>
                            )}
                            {userRole === "ROOTADMIN" && (
                                <NavLink
                                    className="sidebar-link"
                                    activeclassname="active"
                                    to={"/dashboard/objectregistration"}
                                >
                                    <li className={"sidebar-dashboard-li"}>
                                        <Tooltip
                                            title={!isOpen ? "განაცხადის რეგისტრაცია" : ""}>
                                            <div>
                                                <FaPlus className="sidebar-dashboard-icon"/>
                                            </div>
                                        </Tooltip>
                                        {isOpen &&
                                            <span className="sidebar-dashboard-text">განაცხადის რეგისტრაცია</span>}
                                    </li>
                                </NavLink>
                            )}

                        </ul>
                    </div>
                </>)}

        </div>
    );
};

export default Sidebar;
